import {connect, useDispatch} from "react-redux";
import {visibilityStates, complainStatuses} from "../../../app/config";
import {fetchComplains, setFilter, uncheckAllItems} from "../../../app/slices/complainsSlice";
import {FilterMenu} from "../../filterMenu";
import {ScreenHeader} from "../../screenHeader";
import {useTranslation} from "react-i18next";
import MergeComplainsModal from "../../modal/mergeComplainsModal";
import {useState} from "react";
import {showModal} from "../../../app/slices/modalSlice";
import _ from "lodash";
import {format} from "../../../utils/timeZoneUtils";
import {LAYOUT_CONFIG} from "../../../layoutConfig";
import ComplaintService from "../../services/ComplaintService";


function ComplainsTableFilter({filter, hideSearch, hideTitle, selectedItems, csvLink}) {
    const dispatch = useDispatch();
    const {t} = useTranslation('ComplainsScreen', {keyPrefix: 'TableFilter'});
    const {t: tModal} = useTranslation('Modals', {keyPrefix: 'Complaints'});

    const {t: t_common} = useTranslation('Common');
    let timer = null;

    const [showMergeModal, setShowMergeModal] = useState(false);

    const handleFilterChange = (field, value) => {
        clearTimeout(timer);

        dispatch(setFilter({field, value,}));

        timer = setTimeout(() => {
            dispatch(fetchComplains());
        }, 500);
    };

    const handleMergeSelectedComplains = () => {
        if (!selectedItems || selectedItems.length <= 1) {
            dispatch(showModal({
                title: tModal('NoSelectionTitle'),
                message: tModal('NoSelectionMessage'),
                mode: 'danger',
            }));

            return;
        }

        if (selectedItems.some(i => i.transferredToGestalUtc !== null)) {
            const complaint = selectedItems.find(item => item.transferredToGestalUtc !== null);
            dispatch(showModal({
                title: "Case transferred to Consumer Association",
                message: `You cannot merge these cases because case number ${complaint.id} has been transferred to the Consumer Association.`,
                mode: 'danger',
            }));

            return;
        }

        if (!_.every(selectedItems, {mergeInfo: selectedItems[0].mergeInfo})) {
            dispatch(showModal({
                title: tModal('InvalidSelectionTitle'),
                message: tModal('InvalidSelectionMessage'),
                mode: 'danger',
            }));

            return;
        }

        setShowMergeModal(true);
    }

    const onMergeModalComplete = async (isSuccess) => {
        setShowMergeModal(false);

        if (isSuccess) {
            dispatch(showModal({
                title: tModal('MergeSuccess'),
                mode: 'normal',
            }));

            dispatch(uncheckAllItems());
            await dispatch(fetchComplains());
        } else {
            dispatch(showModal({
                title: tModal('MergeError'),
                mode: 'danger',
            }));
        }
    }

    const handleDownloadCsv = async () => {
        await ComplaintService.downloadCsvReport(filter);
    }

    return (
        <>
            {!hideTitle &&
                <ScreenHeader withSearch={!hideSearch} search={filter.search}
                              onChange={(event) => handleFilterChange('search', event.target.value)}/>
            }
            <div className="fk-filter-container --only-filter">
                <div className="fk-filter">
                    <FilterMenu
                        label={t('status.text')}
                        options={complainStatuses}
                        selected={complainStatuses.find(s => s.value === filter.status)}
                        onChange={(option) => handleFilterChange('status', option)}
                        tFunc={t}
                        tPrefix="status."
                    />
                    <FilterMenu
                        label={t('visibility.text')}
                        options={visibilityStates}
                        selected={filter.isPublic}
                        onChange={(option) => handleFilterChange('isPublic', option)}
                        tFunc={t}
                        tPrefix="visibility."
                    />
                    <FilterMenu
                        datepicker
                        label={t('createdAt.text')}
                        options={[]}
                        selected={filter.dateFrom}
                        buttonText={`${t('createdAt.from')} ${filter.dateFrom ? format(filter.dateFrom, "YYYY-MM-DD") : ''}`}
                        onChange={(option) => handleFilterChange('dateFrom', option)}
                    />
                    <FilterMenu
                        datepicker
                        options={[]}
                        selected={filter.dateTo}
                        buttonText={`${t('createdAt.to')} ${filter.dateTo ? format(filter.dateTo, "YYYY-MM-DD") : ''}`}
                        onChange={(option) => handleFilterChange('dateTo', option)}
                    />
                    <FilterMenu
                        actionButton
                        buttonText={t('mergeSelectedComplains')}
                        onClick={handleMergeSelectedComplains}
                    />
                    <FilterMenu
                        actionButton
                        onClick={handleDownloadCsv}
                        buttonText={t_common('downloadCsv')}
                    />
                </div>
            </div>
            <MergeComplainsModal
                show={showMergeModal}
                complains={selectedItems}
                fallback={onMergeModalComplete}
                onCancel={() => setShowMergeModal(false)}
            />
        </>
    );
}

const mapStateToProps = state => ({
    filter: state.complains.filter,
    selectedItems: state.complains.selectedItems,
    csvLink: state.complains.csvLink,
});

export default connect(mapStateToProps, {})(ComplainsTableFilter);